import styled, { keyframes } from "styled-components";
import { theme } from "../../theme/semanticTheme";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  padding: ${theme.spacing.xxl};
  color: ${theme.colors.textMuted};
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid ${theme.colors.border};
  border-top-color: ${theme.colors.accent};
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
  margin-bottom: ${theme.spacing.md};
`;

export const Message = styled.span`
  font-size: ${theme.typography.fontSize.base};
  color: ${theme.colors.textMuted};
`;
